import { makeStyles, Typography, TypographyProps } from "@material-ui/core";
import clsx from "clsx";

type DescriptionProps = TypographyProps & {
  reduceVerticalMargins?: boolean;
};

export function Description(props: DescriptionProps) {
  const classes = useStyles();

  return (
    <Typography
      variant="body1"
      {...props}
      className={clsx(
        classes.content,
        props.className,
        props.reduceVerticalMargins && classes.margin
      )}
    />
  );
}

const useStyles = makeStyles(() => ({
  margin: {
    margin: "-1em 0"
  },
  content: {
    wordWrap: "break-word",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "& pre": {
      whiteSpace: "pre-wrap"
    }
  }
}));
